import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";
import { PANEL_SIZE } from "./defaults";

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const SIZE_OPTIONS = [
  { label: "S", value: PANEL_SIZE.SMALL },
  { label: "M", value: PANEL_SIZE.MEDIUM },
  { label: "L", value: PANEL_SIZE.LARGE },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 12 },
];
